import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "icon-selector"
};
const _hoisted_2 = {
  class: "filter-bar-field-sm relative"
};
const _hoisted_3 = {
  class: "icon-grid"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "py-4 text-center text-sm text-slate-400"
};
import { ref, computed } from 'vue';
import * as HeroIcons from '@heroicons/vue/24/outline';
import CompactFilterBar from '@/components/CompactFilterBar.vue';
export default {
  __name: 'IconSelector',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const searchText = ref('');
    const iconList = Object.keys(HeroIcons).map(name => ({
      name: name.replace(/Icon$/, '').replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, ''),
      component: HeroIcons[name]
    }));
    const filteredIcons = computed(() => {
      if (!searchText.value) return iconList;
      const lower = searchText.value.toLowerCase();
      return iconList.filter(icon => icon.name.toLowerCase().includes(lower));
    });
    function selectIcon(iconName) {
      emit('update:modelValue', iconName);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CompactFilterBar, {
        "shell-class": "mb-3 rounded-xl border border-slate-200 bg-slate-50/70",
        "body-class": "p-3"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("svg", {
          class: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchText.value = $event),
          type: "text",
          class: "form-search-input form-control-sm w-full",
          placeholder: "搜索图标..."
        }, null, 512), [[_vModelText, searchText.value]])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredIcons.value, icon => {
        return _openBlock(), _createElementBlock("div", {
          key: icon.name,
          class: _normalizeClass(["icon-item", {
            active: __props.modelValue === icon.name
          }]),
          onClick: $event => selectIcon(icon.name)
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(icon.component), {
          class: "w-5 h-5"
        }))], 10, _hoisted_4);
      }), 128))]), filteredIcons.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 没有找到匹配的图标 ")) : _createCommentVNode("", true)]);
    };
  }
};